import React from 'react';
import { FaVideo, FaBook } from 'react-icons/fa';
import './CourseTypeSelector.css';

const CourseTypeSelector = ({ selectedType, onChange }) => {
  return (
    <div className="course-type-selector">
      <h3>Select Course Type</h3>
      <div className="type-options">
        <label className={`type-option ${selectedType === 'video' ? 'selected' : ''}`}>
          <input
            type="radio"
            name="courseType"
            value="video"
            checked={selectedType === 'video'}
            onChange={(e) => onChange(e.target.value)}
          />
          <div className="type-content">
            <FaVideo size={32} />
            <span className="type-title">Video Course</span>
            <p className="type-description">
              Create a structured video course with modules, submodules, and lessons
            </p>
          </div>
        </label>

        <label className={`type-option ${selectedType === 'ebook' ? 'selected' : ''}`}>
          <input
            type="radio"
            name="courseType"
            value="ebook"
            checked={selectedType === 'ebook'}
            onChange={(e) => onChange(e.target.value)}
          />
          <div className="type-content">
            <FaBook size={32} />
            <span className="type-title">Ebook</span>
            <p className="type-description">
              Upload a PDF ebook for students to read and learn from
            </p>
          </div>
        </label>
      </div>
    </div>
  );
};

export default CourseTypeSelector;
